import { render, staticRenderFns } from "./SampleNewComponent.vue?vue&type=template&id=96941dc2&"
import script from "./SampleNewComponent.vue?vue&type=script&lang=js&"
export * from "./SampleNewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports